module.exports = __webpack_public_path__ + "static/media/empty-listing.2618e603.png";